//
import WarehouseModel from '@/models/Warehouse/WhWarehouse'

//
export default [
    // {
    //     text: "código(s) upc",
    //     value: "upc_codes",
    // },
    {
        text: 'alias',
        value: 'alias_name',
    },
    {
        text: 'nombre',
        value: 'name',
        component: {
            custom: 'id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'product-update',
                        params: {
                            id: value,
                        },
                    }),
                tooltip: 'Detalle del producto',
            },
        },
    },
    {
        text: 'cantidad',
        value: 'quantityProduct',
        format: 'number',
        align: 'right',
        input: {
            reverse: true,
            type: 'float-field',
        },
    },
    {
        text: 'precio',
        value: 'priceProduct',
        align: 'right',
        format: 'currency',
        input: {
            reverse: true,
            type: 'currency-field',
            trigger(ctx, props) {
                //
                const percentage = props.item.discountPercentageProduct
                const price = props.item.priceProduct
                //
                props.item.discountValueProduct = Math.round( price * ( percentage / 100 ) )
            },
        },
    },
    {
        text: 'descuento ($)',
        value: 'discountValueProduct',
        align: 'right',
        format: 'currency',
        input: {
            reverse: true,
            type: 'currency-field',
            trigger(ctx, props) {
                //
                const discount = props.item.discountValueProduct
                const price = props.item.priceProduct
                //
                props.item.discountPercentageProduct = Math.round( ( discount / price ) * 100 )
            },
        },
    },
    {
        text: 'descuento (%)',
        value: 'discountPercentageProduct',
        align: 'right',
        format: 'percentage',
        input: {
            reverse: true,
            type: 'text-field',
            trigger(ctx, props) {
                //
                const percentage = props.item.discountPercentageProduct
                const price = props.item.priceProduct
                //
                props.item.discountValueProduct = Math.round( price * ( percentage / 100 ) )
            },
        },
    },
    {
        text: 'bodega',
        value: ({ wh_warehouse }) => wh_warehouse ? wh_warehouse.name : 'Sin Bodega',
        input: {
            class: 'ma-0 pa-0',
            custom: 'wh_warehouse',
            itemText: 'name',
            itemValue: 'id',
            itemKey: 'id',
            label: 'Bodega',
            model: WarehouseModel,
            //noObject: true,
            //noAsyncSearch: true,
            outline: false,
            type: 'autocomplete-model',
        },
    },
]
